import React from 'react'
import styled from 'styled-components'
import { IconChevronRight, IconHouse } from '../Icons'
import { Placeholder } from '../Placeholder'

export const BreadcrumbsPlaceholder = () => {
  return (
    <>
      <Desktop>
        <IconHouse
          style={{ width: '1.6rem' }}
          className="d-none d-md-block mr-2"
        />
        <Placeholder width="4rem" />
        <Divider>
          <IconChevronRight width="1rem" height="1rem" className="mr-3" />
        </Divider>
        <Placeholder width="12rem" />
        <Divider>
          <IconChevronRight width="1rem" height="1rem" className="mr-3" />
        </Divider>
        <Placeholder width="8rem" />
      </Desktop>
      <Mobile>
        <IconChevronRight width="1rem" height="1rem" className="mr-3" />
        <Placeholder width="8rem" />
      </Mobile>
    </>
  )
}

const Divider = styled.span.attrs({
  className: 'd-block ml-3',
})`
  line-height: 0.8;
`

const Desktop = styled.div.attrs({
  className: 'd-none d-md-flex align-items-center',
})`
  min-height: 1.6rem;
`

const Mobile = styled.div.attrs({
  className: 'd-flex d-md-none py-3 px-0',
})`
  & > svg {
    transform: rotate(180deg);
  }

  & > div {
    height: 1.2rem;
    background-color: ${({ theme }) => theme.palette.primary};
    opacity: 0.12;
  }
`
